

<template>
  <div class="header" :class="{headerFex:fex}">
    <div class="logo">
      <img @click="toHome" src="../../assets/image/logo.png" alt="">
    </div>
    <div class="navList">
      <div class="navItem fOb" v-for="(v,i) in navList" :key="i" @click="navTap(v,i)">
        {{v.name}}
        <div v-if="i == currenIndex" class="triangle-down"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    fex:{
      type:Boolean,
      default(){
        return true
      }
    },
  },
  computed:{
    currenIndex(){
      return this.$store.getters.pageCurrentIndex;
    }
  },
  data(){
    return {
      headerHeight:104,
      navList:[
        {
          name:'Home',
          url:'Home',
          id:1,
        },
        {
          name:'About Us',
          url:'About',
          id:1,
        },
        {
          name:'Selected Portfolio',
          url:'Portfolio'
        },
        {
          name:'Team',
          url:'Team'
        },
        {
          name:'News',
          url:'News'
        },
        {
          name:'Viewpoint',
          url:'Viewpoint',
        },
        {
          name:'Contact Us',
          url:'Contact'
        }
      ]
    }
  },
  created() {
  },
  methods:{
    toHome(){
      this.$store.dispatch('setPageCurrentIndex',0)

      this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:0})
      if(this.$route.name == 'Home'){
        this.$emit('cCurl')
      }else{
        this.$router.push({name:'Home'})
      }
    },
    /**
     * 跳转
     * @param item
     */
    navTap(item,i){
      if(item.url == 'Home'){
        return this.toHome()
      }
      this.$store.dispatch('setPageCurrentIndex',i)
      this.$router.push({name:item.url})
    }
  }
}
</script>
<style scoped lang="scss">
  .headerFex{
    position: fixed;
  }
  .header{
    width: 100%;
    height: 6.5rem;
    overflow: hidden;
    padding: 0 5rem;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: space-between;
    z-index: 9999;
    .navList{
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1.2rem;
      @media (max-width: 1200px) and (min-width: 1100px) {
        font-size: 1rem;
      }
      @media (max-width: 1099px) {
        font-size: .8rem;
      }
      .navItem{
        cursor: pointer;
        margin-left: 3rem;
        position: relative;
        .triangle-down {
          position: relative;
          width: 0;
          height: 0;
          margin: 0 auto; /* 居中显示 */
        }

        .triangle-down::after {
          content: "";
          position: absolute;
          top: .5rem;
          left: 50%;
          transform: translateX(-50%);
          border-style: solid;
          border-width: 0 6px 6px 6px;
          border-color: transparent transparent #fff transparent;
        }
      }
    }
    .logo{
      cursor: pointer;
      width: 10vw;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
      }
    }
  }
</style>
